
import { defineComponent } from "vue";

export default defineComponent({
  name: "DetailIngredinetSubItem",
  props: {
    description: {
      type: String
    },
    quantity: {
      type: String
    },
    bottomDivider: {
      type: Boolean,
      default: false
    }
  }
});
